import React, { useState } from "react";
import { api } from "../../lib/api";
import { BTN, errMsg } from "./QuickForm";

// Photo evidence through the existing secure upload pipeline (Phase 4: type sniffing, object storage, project-scoped).
export default function PhotoField({ pid, value, onChange, testId }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const add = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    api.post(`/phase4/photos/projects/${pid}`, f, { params: { filename: f.name }, headers: { "Content-Type": f.type || "application/octet-stream" } })
      .then((r) => { onChange([...(value || []), r.data.id]); setErr(""); }).catch((x) => setErr(errMsg(x))).finally(() => setBusy(false));
  };
  return (
    <span className="flex flex-col gap-1">
      <span className={`${BTN} inline-flex items-center justify-center cursor-pointer ${busy ? "opacity-50" : ""}`}>
        {busy ? "Uploading…" : "Take / add photo"}
        <input type="file" accept="image/*" capture="environment" className="sr-only" onChange={add} disabled={busy} data-testid={testId} />
      </span>
      <span className="text-xs" data-testid={`${testId}-count`}>{(value || []).length} photo(s) attached</span>
      {err && <span role="alert" className="text-xs text-red-700" data-testid={`${testId}-error`}>{err}</span>}
    </span>
  );
}
